import { Environment } from './environment-model';

export const environment: Environment = {
    production: false,
    configurationPath: 'assets/configuration/env-configuration.json',
} as any;
